function JourneyProgress({ currentStep = 0 }) {
  const steps = [
    'Verify Mobile',
    'OTP Confirmation',
    'PAN Verification',
    'Upload Selfie',
    'Other Information',
    'Account Aggregator',
    'Banking Details',
    'eKYC & Final Review',
  ];

  return (
    <div className="bg-white border border-gray-200 rounded-3xl p-6 shadow-xl">
      <h3 className="text-lg font-semibold mb-4 flex items-center gap-2 text-gray-800">
        <span className="w-2 h-2 rounded-full bg-theme"></span>
        Journey Progress
      </h3>
      <ol className="space-y-4 text-sm text-gray-600">
        {steps.map((step, index) => (
          <li
            key={step}
            className={`flex items-start gap-3 transition-all ${
              index <= currentStep ? 'opacity-100' : 'opacity-60'
            }`}
          >
            <span
              className={`w-8 h-8 rounded-full border-2 flex items-center justify-center text-xs font-semibold transition-all ${
                index <= currentStep
                  ? 'bg-theme border-theme text-white'
                  : 'border-gray-300 text-gray-400 bg-white'
              }`}
            >
              {index + 1}
            </span>
            <span
              className={`pt-1 transition-colors ${
                index <= currentStep ? 'text-gray-800 font-medium' : 'text-gray-500'
              }`}
            >
              {step}
            </span>
          </li>
        ))}
      </ol>
    </div>
  );
}

export default JourneyProgress;

